<template>
  <bv-home-view class="wap" :router-level="2" style="background: #ffeecc">
    <w-home-header v-if="pageAllData.info" :header="{
        title: { value: `${pageAllData.info.title}` },
        style: `background:` + `${pageAllData.info.background_color}`,
      }" :leftControl="linkUrl($route.query.lifets)">
      <template slot="right-control">
        <div class="bc-t-r bc-pd-r-10">
          <i class="icon fenxiang1 appshare bc-t-333 bc-f-18rp" v-if="config.device.isApp" @click="
              $share({
                title: `${pageAllData.info.share_title}`,
                descr: `${pageAllData.info.share_content}`,
                thumImage: `${pageAllData.info.share_img}`,
              })"></i>
        </div>
      </template>
    </w-home-header>

    <div class="bc-v-m" :style="{ 'margin-top': headerHeight + 'px' }">
      <div class="bc-row" v-if="pageAllData.info">
        <img width="100%" class="_image" :src="`${pageAllData.info.cover_img}`" alt="" />
      </div>

      <div class="bc-v-m" v-if="pageAllData.class_type_1">
        <div class="bc-pd-lr-16rp">
          <!-- 语音朗读 -->
          <div class="phonetic-reading bc-mg-b-30rp bc-pd-lr-16rp" v-for="(item,index) in pageAllData.info.content" :key="index" v-if="pageAllData.info.content && item.type == 'audio'">
            <div class="bc-pd-tb-12rp audio-wrap" :data-id="item.id">
              <w-article-audio :ref='`w_audio${item.id}`' :audio="item" @audioAction='audioAction'></w-article-audio>
            </div>
          </div>

          <!--了解肿瘤及危害-->
          <div class="bc-bg-white bc-bd-radius-8 bc-ps-r bc-mg-b-30rp details-wrap">
            <div class="bc-pd-tb-4rp" v-for="(item, index) in pageAllData.class_type_1" :key="index">
              <router-link :to="`/disease/diseaseKown?id=${item.id}`">
                <img width="100%" :src="`${item.cover_img}`" alt="" />
              </router-link>
            </div>
          </div>
        </div>

        <!-- 新-全息判断 -->
        <div class="bc-w-100">
          <img class="bc-block bc-w-100" :src="`${staticPath}/tumour/new2/head_q.png`" alt="">
          <div class="bc-pd-lr-16rp">
            <div class="bc-flex bc-bg-white bc-flex-d-c bc-flex-ai-c bc-flex-jc-c" style="border-radius:0 0 8px 8px;box-shadow: 0 3px 16px 0 rgba(219, 124, 1, 0.24);">
              <div class="bc-pd-lr-5rp bc-pd-b-16rp" v-for="(item,index) in pageAllData.class_type_2" :key="index">
                <router-link :to="`/disease/diseaseKown?id=${item.id}`" class="bc-block">
                  <img width="100%" class="knowImg" :src='`${item.cover_img}`' alt="">
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- 新-立体干预 -->
        <div class="bc-w-100 bc-mg-b-8rp bc-mg-t-25rp">
          <div class="bgHead_l"></div>
          <div class="bgBody">
            <div class="bc-row bc-w-100 bc-flex bc-flex-w-w bc-pd-lr-24rp bc-pd-b-10rp">
              <div class="bc-t-c bc-mg-tb-3rp" v-for="(item, index) in pageAllData.class_type_3" :key="index" :class="index==0?'bc-w-100':'bc-w-50'" :style="index==0?'flex-shrink:0;':''">
                <router-link :to="`/disease/diseaseKown?id=${item.id}`" class="bc-block">
                  <img class="knowImg" style="width:42vw" :src='`${item.cover_img}`' alt="">
                </router-link>
              </div>
            </div>
          </div>
          <div class="textImg"></div>
          <div class="bgFoot"></div>
        </div>
        <div class="article-content" v-for="(item,index) in pageAllData.info.content" :key="index" v-if="pageAllData.info.content && item.type == 'text'">
          <div v-html="item.value"></div>
        </div>

        <div id="heightFlag">
          <img class="bc-block bc-w-100" :src="`${staticPath}/tumour/bottom-btn.png`" alt="">
        </div>
      </div>
    </div>

    <template slot="other" slot-scope="scope">
      <!--没有绑定手机号分享弹窗-->
      <bv-bind-phone-share @close-bind-phone="closeBindPhoneShare" />
    </template>
  </bv-home-view>
</template>

<script>
import programUrl from "@config/program-url";
import ShareCanvas from "./components/shareCanvas.vue";
import { diseasePublic } from "@views/disease/components/public.js";
import WArticleAudio from '@components/wap/article/w-article-audio/w-article-audio';
import { mapState } from "vuex";

export default {
  mixins: [diseasePublic()],
  data () {
    return {

    };
  },
  computed: {
    staticPath () {
      return `${this.config.path.static}/img/disease`;
    }
  },
  components: {
    ShareCanvas,
    WArticleAudio,
  },
  methods: {
    linkUrl (lifets) {
      //头部返回按钮
      if (lifets && lifets == 1) {
        return "/";
      } else if (lifets && lifets == 2) {
        return "/search";
      } else {
        return programUrl["gou-wu-bao"] + '/home/index/main';
      }
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/ .bv-header {
  position: fixed;
  width: 100%;
}
.article-content /deep/ img{
  width:100% !important;
  display: block;
}
.bgHead_l {
  background: url($base-url + "/img/disease/tumour/new2/head_l.png") no-repeat;
  background-size: 100% 100%;
  height: 26vw;
}
.bgBody {
  margin-top: -1px;
  background: url($base-url + "/img/disease/tumour/new2/body.png") no-repeat;
  background-size: 100% 100%;
}
.bgFoot {
  margin-top: -1px;
  background: url($base-url + "/img/disease/tumour/new2/foot.png") no-repeat;
  background-size: 100% 100%;
  height: 12vw;
}
.textImg {
  margin-top: -1px;
  background: url($base-url + "/img/disease/tumour/new2/text.png") no-repeat;
  background-size: 100% 100%;
  height: 87vw;
}
.background-img {
  height: 19rem;
  background: url($base-url + "/img/disease/tumour/background.png") no-repeat;
  background-size: 100% 100%;
}
.phonetic-reading {
  box-shadow: 0 4px 12px 0 rgba(196, 125, 1, 0.33);
  background: url($base-url + "/img/disease/tumour/audio-bg-img.png") no-repeat;
  background-size: 100% 100%;
  margin-top: -3.3rem;
  position: relative;
  z-index: 100;
  padding: {
    top: rem(56);
    bottom: rem(20);
  }
}
.details-wrap {
  z-index: 100;
  box-shadow: 0 2px 6px 0 rgba(196, 125, 1, 0.33);
}
//改变音频播放器颜色
/deep/ .audioBox {
  background: #fef4e4;
  border: none;
}
/deep/ .mt-range-thumb {
  background: #f18800;
  width: 14px;
  height: 14px;
  top: 4px;
}
/deep/ .mt-range-progress {
  background: #f18800;
}
/deep/ .mt-range-runway {
  border-top-color: #fac07b;
}
/deep/ .playImg {
  width: rem(40);
  height: rem(40);
}
/deep/ .audioTime {
  color: #f28800 !important;
}
</style>
